export default __webpack_public_path__ + "../img/c08833aa83a4b0d223ac144ff2cff4e4.jpg";